/* CVC Direct — kit page.
   Adds every component as its own basket line, then applies the kit discount
   code so the saving lands without the customer typing anything. */
(function () {
  var b = document.getElementById('cvc-kt-add');
  if (!b) return;

  function money(p){ return '\u00a3' + (p/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }

  function toast(m){
    var t = document.getElementById('cvc-co-toast'), x = document.getElementById('cvc-co-toast-text');
    if (!t) return;
    x.textContent = m; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function(){ t.classList.remove('is-on'); }, 3600);
  }

  function refreshHeader(cartUrl){
    fetch(cartUrl, { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(c){
        var t = document.querySelector('.cvc-hd-total');
        if (t) t.textContent = money(c.total_price);
        var w = document.querySelector('.cvc-hd-cart');
        if (!w) return;
        var n = w.querySelector('.cvc-hd-count');
        if (c.item_count > 0) {
          if (!n) { n = document.createElement('span'); n.className = 'cvc-hd-count'; w.insertBefore(n, w.firstChild); }
          n.textContent = c.item_count;
        } else if (n) { n.remove(); }
      }).catch(function(){});
  }

  b.addEventListener('click', function () {
    var items;
    try { items = JSON.parse(b.dataset.items); } catch (e) { items = []; }
    items = (items || []).filter(function (i) { return i && i.id; });
    if (!items.length) { toast('This kit has no items yet'); return; }

    var code = (b.dataset.code || '').trim();
    var label = b.textContent;
    b.disabled = true; b.textContent = 'Adding\u2026';

    fetch(b.dataset.add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.d.description || 'Could not add');
        var n = 0; (res.d.items || []).forEach(function (i) { n += i.quantity; });

        if (code) {
          /* Shopify applies a discount code from this path, then redirects.
             Sending them to the basket means they see the saving applied. */
          b.textContent = 'Applying kit discount\u2026';
          window.location.href = '/discount/' + encodeURIComponent(code) +
            '?redirect=' + encodeURIComponent(b.dataset.cartpage || '/cart');
          return;
        }

        b.classList.add('is-done'); b.textContent = 'Added to basket';
        toast(n + ' item' + (n === 1 ? '' : 's') + ' added as separate lines');
        refreshHeader(b.dataset.cart);
        setTimeout(function () { b.classList.remove('is-done'); b.textContent = label; b.disabled = false; }, 2200);
      })
      .catch(function (err) {
        b.textContent = label; b.disabled = false;
        toast(err.message || 'Could not add to basket');
      });
  });
})();
